<tilby-dialog-toolbar
    [title]="getTitle() | translate"
    [confirmLabel]="getConfirmLabel() | translate"
    [disabled]="isConfirmDisabled() || isWorking"
    [isBack]="isBackStep"
    [hideCancel]="false"
    (backClick)="onBackClick()"
    (confirm)="confirm()">
</tilby-dialog-toolbar>

<tilby-dialog-content [class.working]="isWorking">

    @if (isWorking) {
        <div class="mat-spinner-overlay">
            <div class="tw-flex tw-flex-col tw-items-center">
                <mat-spinner diameter="45"></mat-spinner>
            </div>
        </div>
    }

    @if (errorMessage) {
        <div class="error-banner" (click)="errorMessage = null">
            <span>{{ errorMessage }}</span>
        </div>
    }
    
    @switch (step) {
        @case ('mode-select') {
            <div class="tw-p-4">
                <mat-radio-group [(ngModel)]="sendMode" class="tw-flex tw-flex-col tw-gap-6">
                    
                    @for (option of sendModeOptions; track option.value) {
                        <mat-radio-button [value]="option.value" class="mode-selection-radio">
                            <div class="tw-flex tw-flex-col tw-ml-2">
                                <span class="tw-font-bold tw-text-base tw-mb-1">
                                    {{ option.title | translate }}
                                </span>
                                
                                <span class="tw-text-sm setup-description tw-mb-2">
                                    {{ option.description | translate }}
                                </span>
                                
                                <span class="tw-text-xs tw-font-semibold tw-text-primary">
                                    {{ getSendModePrice(option.priceKey) }}
                                </span>
                            </div>
                        </mat-radio-button>
                    }
                </mat-radio-group>
            </div>
        }

        @case ('merchant-setup') {
            @if(merchantFormReady()) {
                <form [formGroup]="merchantForm" autocomplete="off" class="tw-flex tw-flex-col tw-gap-4 tw-px-2">
                    
                    <!-- SEZIONE GENERAL -->
                    <div>
                        <mat-label class="tw-text-lg" translate>SETTINGS.SETTINGS.GENERAL</mat-label>
                        <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                            <mat-form-field class="tw-col-span-12">
                                <mat-label>{{ 'SETTINGS.SETTINGS.INVOICE_PREFIX' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.invoice_prefix">
                                @if(eInvoiceSetupFormService.invoicePrefix?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        </section>
                    </div>

                    <!-- SEZIONE MERCHANT DATA -->
                    <div>
                        <mat-label class="tw-text-lg" translate>SETTINGS.SETTINGS.MERCHANT_DATA</mat-label>
                        <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.DENOMINATION' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.company_name" required>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.companyName?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.companyNameMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.companyName?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.companyNameMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.companyName?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.FIRST_NAME' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.first_name">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.firstName?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.firstNameMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.firstName?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.firstNameMaxLength}})</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.LAST_NAME' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.last_name">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.lastName?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.lastNameMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.lastName?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.lastNameMaxLength}})</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.COUNTRY' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.country" required>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.country?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.countryMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.country?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.countryMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.country?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.countryMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.country?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <div class="tw-col-span-12 md:tw-col-span-4 tw-flex tw-gap-2">
                                <mat-form-field class="tw-flex-1">
                                    <mat-label>{{ 'SETTINGS.SETTINGS.VAT_CODE' | translate }}</mat-label>
                                    <input matInput formControlName="e_invoice.merchant.vat_code" required>
                                    <button mat-icon-button matSuffix type="button"
                                        class="tw-flex tw-border-0 tw-bg-transparent"
                                        (click)="compileMerchant()" 
                                        [disabled]="isWorking"
                                    >
                                        <mat-icon class="tw-text-gray-500">search</mat-icon>
                                    </button>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.vatCode?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.vatMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.vatCode?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.vatMaxLength}})</mat-error>
                                }
                                </mat-form-field>
                            </div>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.TAX_CODE' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.tax_code">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.taxCode?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.taxCodeMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.taxCode?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.taxCodeMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.taxCode?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.taxCodeMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.taxCode?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.TAX_REGIME' | translate }}</mat-label>
                                <mat-select formControlName="e_invoice.merchant.tax_regime" required>
                                    @for(tr of eInvoiceSetupFormService.taxRegimes; track tr.id) {
                                        <mat-option [value]="tr.id">{{tr.name}}</mat-option>
                                    }
                                </mat-select>
                                @if(eInvoiceSetupFormService.taxRegime?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        </section>
                    </div>

                    <!-- SEZIONE SEDE LEGALE -->
                    <div>
                        <mat-label class="tw-text-lg" translate>SETTINGS.SETTINGS.HEAD_OFFICE</mat-label>
                        <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                            <mat-form-field class="tw-col-span-12 md:tw-col-span-8">
                                <mat-label>{{ 'SETTINGS.SETTINGS.ADDRESS_STREET' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.head_office.street" required>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.addressStreet?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.addressStreetMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.addressStreet?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.addressStreetMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressStreet?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.ADDRESS_NUMBER' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.head_office.number" required>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.addressNumber?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.addressNumberMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.addressNumber?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.addressNumberMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressNumber?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.ADDRESS_ZIP' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.head_office.zip" required>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.addressZip?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.addressZipMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.addressZip?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.addressZipMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressZip?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.addressZipMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressZip?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.ADDRESS_CITY' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.head_office.city" required>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.addressCity?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.addressCityMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.addressCity?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.addressCityMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressCity?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.ADDRESS_PROV' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.head_office.prov" required>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.addressProv?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.addressProvMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.addressProv?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.addressProvMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressProv?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.addressProvMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressProv?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.ADDRESS_COUNTY' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.head_office.country" required>
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.addressCountry?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.addressCountryMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.addressCountry?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.addressCountryMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressCountry?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.addressCountryMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.addressCountry?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        </section>
                    </div>

                    <!-- SEZIONE CONTATTI -->
                    <div>
                        <mat-label class="tw-text-lg" translate>SETTINGS.SETTINGS.CONTACTS</mat-label>
                        <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.PHONE' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.phone">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.phone?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.phoneMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.phone?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.phoneMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.phone?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.phoneMaxLength}})</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.FAX' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.fax">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.fax?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.faxMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.fax?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.faxMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.fax?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.faxMaxLength}})</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.EMAIL' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.email">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.email?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.emailMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.email?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.emailMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.email?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.emailMaxLength}})</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.EMAIL_PEC' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.merchant.email_pec">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.emailPec?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.emailPecMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.emailPec?.hasError('minlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_SHORT' | translate}} (min. {{eInvoiceSetupFormService.validators.emailPecMinLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.emailPec?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.emailPecMaxLength}})</mat-error>
                                }
                            </mat-form-field>
                        </section>
                    </div>

                    <!-- SEZIONE BANK -->
                    <div>
                        <mat-label class="tw-text-lg" translate>SETTINGS.SETTINGS.BANK_MERCHANT</mat-label>
                        <section class="tw-pt-2 tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.BANK_MERCHANT_NAME' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.bank_merchant_name">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.bankMerchantName?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.bankMerchantNameMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.bankMerchantName?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.bankMerchantNameMaxLength}})</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.BANK_NAME' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.bank_name">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.bankName?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.bankNameMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.bankName?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.bankNameMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.bankName?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                                <mat-label>{{ 'SETTINGS.SETTINGS.IBAN' | translate }}</mat-label>
                                <input matInput formControlName="e_invoice.bank_iban">
                                <mat-hint [align]="'end'">{{eInvoiceSetupFormService.bankIban?.value?.length || '0'}}
                                    / {{eInvoiceSetupFormService.validators.bankIbanMaxLength}}</mat-hint>
                                @if(eInvoiceSetupFormService.bankIban?.hasError('maxlength')) {
                                    <mat-error>{{'NG_MESSAGES.VALUE_TOO_LONG' | translate}} (max. {{eInvoiceSetupFormService.validators.bankIbanMaxLength}})</mat-error>
                                } @else if(eInvoiceSetupFormService.bankIban?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        </section>
                    </div>

                </form>
            }
        }

        @case ('digitalhub-owned-setup') {
            @if(digitalHubFormReady()) {
                <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pb-2">
                    <div class="tw-w-full tw-max-w-[450px] tw-px-6 tw-flex tw-flex-col tw-gap-6">
                        <div class="tw-flex tw-justify-center">
                            <img src="assets/images/history/digital_hub.png" class="tw-h-auto tw-max-w-[220px]" alt="Digital Hub Logo">
                        </div>

                        <form [formGroup]="digitalHubForm" class="tw-w-full tw-flex tw-flex-col tw-gap-2">
                            <mat-form-field class="tw-col-span-12">
                                <mat-label>{{ 'HISTORY.E_INVOICE_SETUP.DIGITAL_HUB_OWNED.USERNAME' | translate }}</mat-label>
                                <input matInput formControlName="userName" required>
                                @if(eInvoiceSetupFormService.digitalHubUserName?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
        
                            <mat-form-field class="tw-col-span-12">
                                <mat-label>{{ 'HISTORY.E_INVOICE_SETUP.DIGITAL_HUB_OWNED.PASSWORD' | translate }}</mat-label>
                                <input matInput type="password" formControlName="password" required>
                                @if(eInvoiceSetupFormService.digitalHubPassword?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        </form>
                    </div>
                </div>
            }
        }

        @case ('ftp-setup') {
            @if(ftpFormReady()) {
                <form [formGroup]="ftpForm" class="tw-flex tw-flex-col tw-gap-5 tw-px-2">
                    <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-2">
                        <mat-form-field class="tw-col-span-12">
                            <mat-label>{{ 'HISTORY.E_INVOICE_SETUP.FTP.PROTOCOL' | translate }}</mat-label>
                            <mat-select formControlName="protocol" required>
                                <mat-option value="ftp">{{ 'HISTORY.E_INVOICE_SETUP.FTP.PROTOCOL_FTP' | translate }}</mat-option>
                                <mat-option value="sftp">{{ 'HISTORY.E_INVOICE_SETUP.FTP.PROTOCOL_SFTP' | translate }}</mat-option>
                            </mat-select>
                            @if(eInvoiceSetupFormService.ftpProtocol?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        <mat-form-field class="tw-col-span-12 md:tw-col-span-8">
                            <mat-label>{{ 'HISTORY.E_INVOICE_SETUP.FTP.HOSTNAME' | translate }}</mat-label>
                            <input matInput formControlName="host" required placeholder="ftp.esempio.it">
                            @if(eInvoiceSetupFormService.ftpHost?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        <mat-form-field class="tw-col-span-12 md:tw-col-span-4">
                            <mat-label>{{ 'HISTORY.E_INVOICE_SETUP.FTP.PORT' | translate }}</mat-label>
                            <input matInput type="number" formControlName="port">
                            @if(eInvoiceSetupFormService.ftpPort?.hasError('min') || eInvoiceSetupFormService.ftpPort?.hasError('max')) {
                                <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                            }  @else if(eInvoiceSetupFormService.ftpPort?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                            <mat-label>{{ 'HISTORY.E_INVOICE_SETUP.FTP.USERNAME' | translate }}</mat-label>
                            <input matInput formControlName="user" required>
                            @if(eInvoiceSetupFormService.ftpUser?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                            <mat-label>{{ 'HISTORY.E_INVOICE_SETUP.FTP.PASSWORD' | translate }}</mat-label>
                            <input matInput type="password" formControlName="password" required>
                            @if(eInvoiceSetupFormService.ftpPassword?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>
        
                        <mat-form-field class="tw-col-span-12">
                            <mat-label>{{ 'HISTORY.E_INVOICE_SETUP.FTP.PATH' | translate }}</mat-label>
                            <input matInput formControlName="path" placeholder="/cartella/fatture">
                        </mat-form-field>
        
                        @if (ftpForm.get('protocol')?.value === 'ftp') {
                            <div class="tw-col-span-12 tw-flex tw-items-center tw-p-2">
                                <mat-slide-toggle formControlName="secure" color="primary">
                                    {{ 'HISTORY.E_INVOICE_SETUP.FTP.SECURE' | translate }}
                                </mat-slide-toggle>
                            </div>
                        }
                    </section>
                    
                </form>
            }
        }
        
    }
</tilby-dialog-content>
